import { Modal, Space, Spin } from '@bedrock/components'
import Empty404 from '@bedrock/components/es/Empty/images/large/404'
import React from 'react'

const LoadingModal = ({
  visible,
}) => {
  return (
    <Modal
      title={null}
      closable={false}
      width={400}
      okButton={false}
      cancelButton={false}
      visible={visible}
    >
      <div className='flex flex-col items-center gap-4'>
        <Empty404 className='mt-[40px]' />
        <div>
          <Space size='xxs'>
            <Spin size='xSmall' />
            <span>导入成功，正在匹配达人中...</span>
          </Space>
        </div>
      </div>
    </Modal>
  )
}

export default LoadingModal
